<template>
  <div>
    <div v-if="tipoIdPaiLocale === 7">
      <v-textarea
        v-model="nodeDataLocale.botaoOpcaoTitle"
        label="Título do botão *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required, (v) => (!!v && v.length <= 60) || 'Máximo de 60 caracteres']"
        @change="nodeConfig"
      />

      <v-divider class="mt-3 mb-3"></v-divider>

      <span class="d-flex justify-center mt-1 mb-3 font-weight-semibold text--secondary">Configurações do tipo texto</span>
    </div>

    <div v-if="tipoIdPaiLocale === 8">
      <v-textarea
        v-model="nodeDataLocale.listaOpcaoTitle"
        label="Título da lista *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required, (v) => (!!v && v.length <= 24) || 'Máximo de 24 caracteres']"
        @change="nodeConfig"
      />

      <v-textarea
        v-model="nodeDataLocale.listaOpcaoDescription"
        label="Descrição da lista"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[(v) => (!!v && v.length <= 72) || 'Máximo de 72 caracteres']"
        @change="nodeConfig"
      />

      <v-divider class="mt-3 mb-3"></v-divider>

      <span class="d-flex justify-center mt-1 mb-3 font-weight-semibold text--secondary">Configurações do tipo texto</span>
    </div>

    <div v-if="tipoIdPaiLocale !== 7 || tipoIdPaiLocale !== 8">
      <v-textarea
        v-model="nodeDataLocale.textoSelecao"
        label="Mensagem *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required]"
        @change="nodeConfig"
      />
    </div>

    <div class="d-flex align-center justify-center">
      <v-col
        cols="12"
        sm="6"
      >
        <drag-and-drop-file class="mt-2 mb-5" />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-row>
          <v-text-field
            v-model="exibicaoArquivo.nome"
            outlined
            dense
            prefix="Nome do arquivo:"
            hide-details="auto"
            class="mb-2"
            filled
            readonly
          >
          </v-text-field>

          <v-text-field
            v-model="exibicaoArquivo.tipo"
            outlined
            prefix="Tipo do arquivo:"
            dense
            hide-details="auto"
            class="mt-2"
            filled
            readonly
          >
          </v-text-field>
        </v-row>
      </v-col>
    </div>

    <v-tooltip
      top
      color="primary"
    >
      <template
        v-slot:activator="{ on, attrs }"
      >
        <v-checkbox
          v-if="!nodeDataLocale.id && nodeDataLocale.nosFilhos.length <= 0"
          v-model="nodeDataLocale.adicionarSubNosParaVoltarEEncerrar"
          label="Criar opções padrão e adicionar mensagem final personalizada"
          v-bind="attrs"
          v-on="on"
          @change="nodeConfig"
        />
      </template>
      <span>Não permite criar outra opção nesse nó</span>
    </v-tooltip>

    <v-textarea
      v-if="nodeDataLocale.adicionarSubNosParaVoltarEEncerrar"
      v-model="nodeDataLocale.mensagemEncerramento"
      label="Mensagem Final Personalizada"
      placeholder="Digite uma Mensagem"
      outlined
      auto-grow
      rows="1"
      row-height="15"
      class="mt-2"
      @change="nodeConfig"
    />

    <v-textarea
      v-model="opcoes"
      label="Opções"
      placeholder="Opções"
      outlined
      auto-grow
      readonly
      filled
      rows="1"
      row-height="15"
      class="mt-2"
    ></v-textarea>
  </div>
</template>

<script>
import {
  computed,
  inject, ref, watch,
} from '@vue/composition-api'
import { required, select } from '@/@core/utils/validation'
import NodeChatBotModel from '@/models/entities/chat-bot/NodeChatBotModel'
import DragAndDropFile from './DragAndDropFile.vue'

export default {
  components: {
    DragAndDropFile,
  },

  props: {
  },

  setup(props, { emit }) {
    const opcoes = ref([])
    function exibirOpcoesDoNo(data) {
      let concat = ''
      if (data.chatBotNoTipoId === 1) {
        if (data.nosFilhos.length > 0) {
          data.nosFilhos.forEach(element => {
            concat += `${element.numero} - ${element.texto}\n`
          })
        }
      }
      opcoes.value = concat
    }

    const nodeDataLocale = ref(new NodeChatBotModel())
    const nodeData = inject('nodeData')
    watch(() => nodeData.value, value => {
      nodeDataLocale.value = value
      exibirOpcoesDoNo(value)
    }, { immediate: true, deep: true })

    const tipoIdPaiLocale = ref(0)
    const tipoIdPai = inject('nodeTipoIdPai')
    watch(() => tipoIdPai.value, value => {
      tipoIdPaiLocale.value = value
    }, { immediate: true, deep: true })

    function nodeConfig() {
      emit('node-config')
    }

    const exibicaoArquivo = computed(() => {
      let data = {}
      if (nodeDataLocale.value.arquivoStorageId) {
        const nome = nodeDataLocale.value.arquivoNome.split('.')[0]
        const tipo = nodeDataLocale.value.arquivoNome.split('.')[1]
        data = {
          nome,
          tipo,
        }
      }
      return data
    })

    return {
      nodeConfig,
      exibicaoArquivo,
      nodeDataLocale,
      tipoIdPaiLocale,
      opcoes,
      validators: {
        required,
        select,
      },
    }
  },
}
</script>
